/*************************************************/
/* QUESTIONS                                     */
/*************************************************/

export function questions() {
    var revealBtns = document.querySelectorAll(".revealBtn");
    var currentlyOpenElement = null; // Track the currently open element

    function handleShowMore(container) {
        const showMoreButton = container.querySelector(".show-more-button");
        const showLessButton = container.querySelector(".show-less-button");
        const mobileToggleButton = container.querySelector(".service-links__servicename");

        showMoreButton.addEventListener("click", function (event) {
            if (showMoreButton) {
                const hiddenItems = container.querySelectorAll(".download-item__download-item.hidden");
                hiddenItems.forEach(function (item) {
                    item.classList.remove("hidden");
                });

                showMoreButton.style.display = "none";
                showLessButton.style.display = "flex";
            }
        });

        showLessButton.addEventListener("click", function (event) {
            if (showLessButton) {
                const allItems = container.querySelectorAll(".download-item__download-item");
                allItems.forEach(function (item) {
                    item.classList.add("hidden");
                });

                showMoreButton.style.display = "flex";
                showLessButton.style.display = "none"; // Hide the clicked button
            }
        })

        mobileToggleButton.addEventListener("click", function (event) {
            let isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;
            const boxLink = container.querySelector(".service-links__box-links");
            const transformClass = "service-links__servicename-transform";
            const linkItem = container.querySelector(".download-item");
            let isShown = boxLink.style.display == "flex";

            if (isMobile) {
                if (isShown) {
                    boxLink.style.display = "none";
                    mobileToggleButton.classList.remove(transformClass);
                    
                } else {
                    boxLink.style.display = "flex";
                    mobileToggleButton.classList.add(transformClass);
                }
            }
        })
    }

    document.addEventListener("DOMContentLoaded", function () {
        const downloadContainers = document.querySelectorAll(".download-item");

        downloadContainers.forEach(function (container) {
            handleShowMore(container);
        });
    });

    revealBtns.forEach(element => {
        element.addEventListener("click", () => {
            if (currentlyOpenElement && currentlyOpenElement !== element) {
                // Close the currently open element
                currentlyOpenElement.nextElementSibling.classList.remove("visible");
            }

            // Toggle the visibility of the clicked element
            element.nextElementSibling.classList.toggle("visible");

            // Update the currently open element
            currentlyOpenElement = currentlyOpenElement === element ? null : element;
        });
    });
}